<template>
  <div id="app">
    <div class="container">
        <huHeader/>
        <router-view/>
    </div>
    <huFooter/>
  </div>
</template>
<script>
import huFooter from '@/components/huFooter.vue';
import huHeader from '@/components/huHeader.vue';
export default {
  components:{huFooter,huHeader}
}
</script>
<style lang="scss">
  

  header{
    margin-top:50px;
  }
  #app {
    text-align: left;
    color: #fff;
  }


</style>
